import React from 'react'

import './banners.css'
import { Link } from 'react-router-dom'

import IconAlert from '../../media/felsv/WarningErrorWhite.svg'
import { useSelector } from 'react-redux'
import { State } from '../../reducers'

export const BannerElegirSucursal = () => {
  const {datos} = useSelector((state: State) => state.userLogin) 

  return (
    <>
      {
        (datos.id && !datos.sucursal_seleccionada)
        ?
        <div className="banner-card">
          <p>
            <img src={IconAlert} width={20} />
            Para poder emitir documentos debes seleccionar una sucursal en la <Link style={{color: '#FFF'}} to={'/user/profile'}>configuración del perfil</Link> 
          </p>
        </div>
        :
        (null)
      }
    </>
  )
}
